import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
// Import of the module

import { ExternalLink } from "@/components/ExternalLink";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type S1Metadata = {
  id: number;
  owner_type: string;
  owner_id: number;
  owner_name?: string;
  field_key: string;
  field_value: string | null;
  created_at: string;
  updated_at: string;
};

// Definition of the columns

export const s1_metadata_columns: ColumnDef<S1Metadata>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "owner_name",
    header: "Owner",
    cell: ({ row }) => {
      const ownerId = row.original.owner_id;
      const ownerName = row.original.owner_name;
      const ownerType = row.original.owner_type;

      // Determine the correct route based on owner_type
      const getOwnerRoute = () => {
        if (ownerType === "Strategy") {
          return toWorkspacePath(
            `/admin/qtl - referential/strategies/${ownerId}`,
          );
        } else if (ownerType === "Link") {
          return toWorkspacePath(`/admin/s1/s1_portfolios/${ownerId}`);
        }
        return toWorkspacePath(
          `/admin/qtl - referential/strategies/${ownerId}`,
        ); // default fallback
      };

      return (
        <ExternalLink
          href={getOwnerRoute()}
          className="text-xs"
          underline="hover"
        >
          {ownerName}
        </ExternalLink>
      );
    },
  },
  {
    accessorKey: "owner_type",
    header: "Owner Type",
  },
  {
    accessorKey: "field_key",
    header: "Field Key",
  },
  {
    accessorKey: "field_value",
    header: "Field Value",
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
